import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, inject } from '@angular/core';
import { MessageContentUnion } from '@airgram/web';
import { TelegramMessengerService } from '@src/app/modules/telegram';
import { MessageModel, SponsoredMessageUI } from '@src/models';

@Component({
  selector: 'app-message-notification',
  templateUrl: './message-notification.component.html',
  styleUrls: ['../styles/message-content.scss', './message-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageNotificationComponent {
  private readonly messengerService = inject(TelegramMessengerService);

  @Input() set message(mess: MessageModel | undefined) {
    this.content = mess?.content;

    const senderId = mess?.senderId;
    this.whoId = senderId?._ === 'messageSenderUser' ? senderId.userId : senderId?.chatId;

    if (this.content?._ === 'messageChatAddMembers') {
      this.chatMembersIds = this.content.memberUserIds;
    }

    if (this.content?._ === 'messageChatDeleteMember') {
      this.chatMembersIds = [this.content.userId];
    }

    if (this.content?._ === 'messagePinMessage' && mess) {
      this.pinnedMessage$ = this.messengerService.api.getMessage(mess.chatId, this.content.messageId);
    }
  }

  @Output() gotoPinnedMessage = new EventEmitter<number>();

  content?: MessageContentUnion;
  whoId?: number;
  chatMembersIds?: number[];
  pinnedMessage$?: Promise<MessageModel | SponsoredMessageUI>;

  onClickPinnedMessage(messageId: number) {
    this.gotoPinnedMessage.emit(messageId);
  }
}
